import { combineReducers } from '@ynap/reducer-utils';
import * as reducers from './reducers';

const authReducer = combineReducers({ ...reducers });

export default authReducer;
